export const isComcast = (): boolean => {
  const ua = window.navigator.userAgent
  if (/Sky/.test(ua)) {
    return true
  }
  if (typeof window.__firebolt === 'undefined') {
    return false
  }
  const firebolt = window.__firebolt as { [key: string]: any }
  if (typeof firebolt.transport !== 'undefined' || typeof firebolt.endpoint !== 'undefined') {
    return true
  }
  return false
}
